import React, { useState } from "react";
import {
  Paper,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Container,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { Input, DatePicker, Space, Select } from "antd";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useDispatch } from "react-redux";
import { addUser } from "../../../Redux/Slices/userSlice";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { addEventMainStyles, SettingsStyles } from "../../../Styles/styles";

const InputPic = styled("input")({
  display: "none",
});

const initialState = {
  name: "",
  event: "",
  ticketType: "",
  bookingDate: "",
  status: false,
  image: null,
};

export default function AddRaffle() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userData, setUserData] = useState(initialState);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handlePhotoChange = (e) => {
    setUserData({ ...userData, image: URL.createObjectURL(e.target.files[0]) });
  };

  const handleStatusChange = () => {
    setUserData({ ...userData, status: !userData.status });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      const newUser = {
        ...userData,
        id: Date.now(),
      };
      dispatch(addUser(newUser));
      setSnackbarMessage("User successfully added");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setUserData(initialState);
    } catch (error) {
      setSnackbarMessage("Error adding user");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return (
    <Grid p={1.5}>
      <Paper elevation={1} sx={{ padding: 2, height:"89vh"}}>
        <Grid p={2} sx={{ overflowX: "hidden" }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
                <Grid
                  container
                  md={12}
                  sx={{ justifyContent: "space-between" }}
                >
                  <Grid item md={6}>
                    <Typography variant="body1">Add Raffle</Typography>
                  </Grid>
                  <Grid item md={6}>
                    <Typography variant="body1" sx={{ color: "silver" }}>
                      {formattedDate}
                    </Typography>
                  </Grid>
                </Grid>
                <Box mt={3}>
                  <Box mb={1}>
                    <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                      Title
                    </Typography>
                    <Input
                      size="large"
                      placeholder="Title"
                      name="title"
                      value={userData.name}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box mb={1}>
                    <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                      Purpose
                    </Typography>
                    <Input
                      size="large"
                      placeholder="Purpose"
                      name="purpose"
                      value={userData.event}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Box>
                  <Box mb={1}>
                    <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                      Monetary Award
                    </Typography>
                    <Input
                      size="large"
                      placeholder="Monetary Award"
                      name="monetaryAward"
                      value={userData.ticketType}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box mb={1}>
                    <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                      Winning Date
                    </Typography>
                    <Input
                      size="large"
                      placeholder="Winning Date"
                      name="winningDate"
                      value={userData.bookingDate}
                      onChange={handleChange}
                    />
                    {/* <DatePicker
                      style={{ width: "100%" }}
                      size="large"
                      onChange={onDateChange}
                    /> */}
                  </Box>
                  <Box mb={1}>
                    <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                      Total Tickets
                    </Typography>
                    <Input
                      size="large"
                      placeholder="Total Tickets"
                      name="totalTickets"
                      value={userData.bookingDate}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box mb={1}>
                    <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                      Tickets Price
                    </Typography>
                    <Input
                      size="large"
                      placeholder="Tickets Price"
                      name="ticketsPrice"
                      value={userData.bookingDate}
                      onChange={handleChange}
                    />
                    {/* <DatePicker
                      style={{ width: "100%" }}
                      size="large"
                      onChange={onDateChange}
                    /> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                mt: {xl:20, lg:10, md:10, xs:4},
                mr: 2,
                float: "right",
                flexDirection: { md: "row", sm: "column", xs: "column" },
              }}
            >
              <Button
                type="submit"
                sx={SettingsStyles.UpdateBtnStyles}
                variant="contained"
                color="primary"
              >
                Create
              </Button>
            </Box>
          </form>
        </Grid>
      </Paper>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
}
